import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserApiService } from './user.service';
import { AuthGuard } from './Guard';
import { BasicAuthInterceptor } from './BasicAuthInterceptor';


@NgModule({
    providers: [ UserApiService, AuthGuard, { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true } ],
})
export class UserApiModule {}
